// extracted by mini-css-extract-plugin
export default {"heading":"Iv-z","corrected":"Jv-z","redirectVerbiageContainer":"Kv-z","redirectVerbiageText":"Lv-z"};